import { z } from 'zod';

export const ApiError = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
  }),
});
export type ApiError = z.infer<typeof ApiError>;

export const ErrorCodes = {
  RATE_LIMITED: 'RATE_LIMITED',
  SPEND_CAP: 'SPEND_CAP',
  TOO_MANY_PAGES: 'TOO_MANY_PAGES',
  IMAGE_TOO_LARGE: 'IMAGE_TOO_LARGE',
  UNSUPPORTED_IMAGE: 'UNSUPPORTED_IMAGE',
  GEMINI_TIMEOUT: 'GEMINI_TIMEOUT',
  GEMINI_FAILED: 'GEMINI_FAILED',
  NOT_A_MENU: 'NOT_A_MENU',
  NOT_FOUND: 'NOT_FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
  INVALID_INPUT: 'INVALID_INPUT',
  INTERNAL: 'INTERNAL',
  // Client-side: detected via navigator.onLine before/after a scan attempt.
  // Never returned by the server.
  OFFLINE: 'OFFLINE',
} as const;
export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];
